import Grid from '../../../../../../components/Table/Grid';
import { GridContainerProps } from '../types';

export function GridContainer({
  columns,
  columnVisibilityModel,
  columnOrder,
  setColumnOrder,
  view,
  source,
  tab,
  panelTab,
  searchItems,
  isEvidence,
  isMapping,
  setTotalResults,
  onData,
  getFilterValueRef,
  defaultFilterValue,
  sourceWeights,
  isInvalidSource,
  enableEnrichmentSelection,
  getRowId,
  getRowIdForEnrichment,
  enrichmentGetSelectionRef,
}: GridContainerProps) {
  if (isInvalidSource && columns) {
    return (
      <div className="text-center text-gray-500 italic p-6">
        <strong>{source}</strong> is not a source for <strong>{tab}</strong>
      </div>
    );
  }

  return (
    <Grid
      columns={columns}
      columnVisibilityModel={columnVisibilityModel}
      columnOrder={columnOrder}
      setColumnOrder={setColumnOrder}
      view={view}
      source={source}
      tab={tab}
      panelTab={panelTab}
      searchItems={searchItems}
      isEvidence={isEvidence}
      isMapping={isMapping}
      setTotalResults={setTotalResults}
      onData={onData}
      getFilterValueRef={getFilterValueRef}
      defaultFilterValue={defaultFilterValue}
      sourceWeights={sourceWeights}
      enableEnrichmentSelection={enableEnrichmentSelection}
      getRowId={getRowId}
      getRowIdForEnrichment={getRowIdForEnrichment}
      enrichmentGetSelectionRef={enrichmentGetSelectionRef}
    />
  );
}